module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "about-the-author"
    }
  }, [_c('h1', [_vm._v("About the Author")]), _vm._v(" "), _c('p', [_vm._v("William Hardy lives in Spartanburg, SC, with his wife, Nancy. Not only being the published author of "), _c('em', [_vm._v("Hell’s Island")]), _vm._v(", he also is a founding member and guitarist with the J Teal Band, and wrote three songs on their album, "), _c('em', [_vm._v("Cooks,")]), _vm._v(" which was officially released on Rockadrome Records and distributed and sold worldwide. He is presently working on his next book, "), _c('em', [_vm._v("Gullah Gravestones II")]), _vm._v(".")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ad60488","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch001.vue
// module id = 63
// module chunks = 0